import shubhamLogo from "../../../asset/images/shubham_removebg.png";

export const SHUBHAM_BRAND = {
  companyName: "Shubham",
  logo: shubhamLogo,
};
